import cn from 'classnames';
import { forwardRef } from 'react';
import { createPortal } from 'react-dom';
import { resolveValue, useToaster } from 'react-hot-toast/headless';

import { ToastWrapper } from './toast-wrapper';

import type { ForwardedRef } from 'react';

import type { ToasterProps } from './toaster.types';

import './toaster.scss';

export const Toaster = forwardRef((props: ToasterProps, forwardedRef: ForwardedRef<HTMLDivElement>) => {
  const { className, duration = 5000 } = props;
  const {
    handlers: { calculateOffset, endPause, startPause, updateHeight },
    toasts,
  } = useToaster({ duration, position: 'top-center', removeDelay: 400 });

  return createPortal(
    <div
      className={cn('rbui-toaster', className)}
      id="rbui-toaster"
      onBlur={endPause}
      onFocus={startPause}
      onMouseEnter={startPause}
      onMouseLeave={endPause}
      ref={forwardedRef}
    >
      {toasts.map((toast) => {
        const offset = calculateOffset(toast, {
          defaultPosition: 'top-center',
          gutter: 16,
          reverseOrder: false,
        });

        return (
          <ToastWrapper
            className={cn('rbui-toast-wrapper', toast.visible && 'rbui-toast-wrapper--visible')}
            key={toast.id}
            onHeightUpdate={updateHeight}
            style={{ transform: `translateY(${offset}px)` }}
            toast={toast}
          >
            {resolveValue(toast.message, toast)}
          </ToastWrapper>
        );
      })}
    </div>,
    document.body,
  );
});
